export function nav() {
	function toggleMenu() {
		var body = document.querySelector('body')
		var nav__button = document.querySelector('.nav__button')

		if (body.classList.contains('js-nav-open')) {
			body.classList.remove('js-nav-open')
			if (nav__button) nav__button.classList.remove('is-active')
		} else {
			body.classList.add('js-nav-open')
			if (nav__button) nav__button.classList.add('is-active')
		}
	}

	document.querySelectorAll('.js-nav__button').forEach((item) => item.addEventListener('click', toggleMenu))
	document.querySelectorAll('.nav__site li:not(.has-children)').forEach((item) => item.addEventListener('click', toggleMenu))

	// hide header on scroll down ==========================================
	const header = document.querySelector('.site__header')
	const filter = document.querySelector('.section--search')
	if (header) if (!filter) header.classList.add('no-filter')

	if (header) {
		header.classList.add('nav-down')
		let headerHeight = header.offsetHeight,
			prevScrollPos = window.pageYOffset

		window.addEventListener('scroll', (e) => {
			let currentScrollPos = window.pageYOffset

			// Hide when scrolling down
			if (currentScrollPos <= headerHeight || prevScrollPos > currentScrollPos || currentScrollPos < window.innerHeight * 0.1) {
				header.classList.add('nav-down')
				header.classList.remove('nav-up')
				if (filter) filter.classList.remove('nav-up')
			} else {
				if (filter) filter.classList.add('nav-up')
				header.classList.remove('nav-down')
				header.classList.add('nav-up')
			}

			prevScrollPos = currentScrollPos
		})
	}
}
